module.exports = __webpack_public_path__ + "static/media/gridBlue.3d2fa77d.png";